import React from 'react';

function OpportunityCheckin({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M7 14v2h2v-2h2.036c-.101.448-.154.913-.154 1.391 0 1.079.305 2.212.848 3.418.323.716.727 1.448 1.197 2.191H5c-1.11 0-2-.89-2-2l.01-5H7zm7-11c1.11 0 2 .89 2 2v1h4c1.05 0 1.918.82 1.994 1.851L22 8v2.892A6.539 6.539 0 0017.383 9c-2.727 0-5.068 1.65-6.031 4H9v-2H7v2H4c-1.11 0-2-.89-2-2V8c0-1.1.9-2 2-2h3.999L8 5c0-1.06.81-1.919 1.85-1.995L10 3zm0 2h-4v1h4V5z"
                    fill={color}
                />
                <path
                    d="M17.5 11c-2.488 0-4.5 2.034-4.5 4.55 0 3.412 4.5 8.45 4.5 8.45s4.5-5.038 4.5-8.45c0-2.516-2.012-4.55-4.5-4.55zm-.15 5.881c-.745 0-1.35-.624-1.35-1.393s.605-1.393 1.35-1.393c.745 0 1.35.624 1.35 1.393s-.605 1.393-1.35 1.393z"
                    fill="#007E45"
                />
            </g>
        </svg>
    );
}

export default OpportunityCheckin;
